import Player from '@/models/Player';

export default class Team {
  /**
   * Создаёт команду.
   * @param {string} [name=''] - Название команды.
   * @param {string|string[]} [clubId=[]] - Клубы, к которым относится команда.
   * @param {Array<Player|Object>} [players=[]] - Игроки команды.
   */
  constructor(name = '', clubId = [], players = []) {
    this.id = null;
    this.name = name;
    this.clubId = Array.isArray(clubId) ? clubId : (clubId ? [clubId] : []);
    this.players = players.map((player) => (player instanceof Player ? player : Player.fromObject(player)));
    this.captainId = null;
    this.isActive = true;
    this.createdAt = new Date().toISOString();
    this.updatedAt = new Date().toISOString();
  }

  /**
   * Создаёт экземпляр Team из plain object.
   * @param {Object} [obj={}]
   * @returns {Team}
   */
  static fromObject(obj = {}) {
    const team = new Team(obj.name || '', obj.clubId || [], obj.players || []);
    team.id = obj.id || null;
    team.captainId = obj.captainId || null;
    team.isActive = obj.isActive ?? true;
    team.createdAt = obj.createdAt || new Date().toISOString();
    team.updatedAt = obj.updatedAt || team.createdAt;
    return team;
  }

  /**
   * Считает средний рейтинг указанного состава для выбранного контроля.
   * Нулевой или отсутствующий рейтинг игрока учитывается как 1500 только для среднего.
   * @param {string|null} controlType
   * @param {Array<Player|Object>} [players=[]]
   * @returns {{controlType: string|null, rating: number|null, memberCount: number, source: string}}
   */
  static getRatingInfoForPlayers(controlType = null, players = []) {
    const members = Array.isArray(players) ? players : [];
    const ratingValues = members.map((player) => {
      const rating = player?.getRatingInfo?.(controlType)?.rating;
      return (typeof rating === 'number' && !Number.isNaN(rating) && rating > 0)
        ? rating
        : 1500;
    });

    const averageRating = ratingValues.length
      ? Math.round(ratingValues.reduce((sum, value) => sum + value, 0) / ratingValues.length)
      : null;

    return {
      controlType,
      rating: averageRating,
      memberCount: members.length,
      source: 'team-average',
    };
  }

  /**
   * Считает средний рейтинг команды для указанного контроля.
   * Нулевой или отсутствующий рейтинг игрока учитывается как 1500 только для среднего.
   * @param {string|null} controlType
   * @param {Array<Player|Object>|null} [players=null] - Состав для расчёта; если не передан, используется this.players.
   * @returns {{controlType: string|null, rating: number|null, memberCount: number, source: string}}
   */
  getRatingInfo(controlType = null, players = null) {
    const members = Array.isArray(players) ? players : (Array.isArray(this.players) ? this.players : []);
    return Team.getRatingInfoForPlayers(controlType, members);
  }
}
